// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-csv-link {
    color: rgb(255, 255, 255);
    text-decoration: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/CustomToolbar.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,qBAAqB;EACvB","sourcesContent":[".custom-csv-link {\n    color: rgb(255, 255, 255);\n    text-decoration: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
